import React from 'react';
import ForgotPasswordComponent from '../../components/ForgotPassword/forgot_password_component';

class ForgotPassPage extends React.Component {
  render() {
    return (
      <ForgotPasswordComponent />
    );
  }
}

export default ForgotPassPage;
